/* ==========================================================================
   LUNÉA COSMETICS — Theme interacties
   Vanilla JS, geen afhankelijkheden. Progressive enhancement:
   zonder JS blijft alle inhoud leesbaar en bereikbaar.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------------
     1. Carrousel-navigatie (.lu-rail)
     ---------------------------------------------------------------------- */
  function initRail(wrapper) {
    var rail = $('[data-lu-rail]', wrapper);
    var prev = $('[data-lu-rail-prev]', wrapper);
    var next = $('[data-lu-rail-next]', wrapper);
    if (!rail) return;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    function scrollBy(dir) {
      rail.scrollBy({ left: step() * dir, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ------------------------------------------------------------------------
     2. Aftelklok (.lu-countdown) — data-lu-countdown="ISO datum" of
        data-lu-daily="22:00" voor een dagelijkse deadline (bestel-voor)
     ---------------------------------------------------------------------- */
  function nextDailyDeadline(hhmm) {
    var parts = String(hhmm).split(':');
    var h = parseInt(parts[0], 10) || 0;
    var m = parseInt(parts[1], 10) || 0;
    var now = new Date();
    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0, 0);
    if (target <= now) target.setDate(target.getDate() + 1);
    return target;
  }

  function initCountdown(el) {
    var target;
    if (el.hasAttribute('data-lu-daily')) {
      target = nextDailyDeadline(el.getAttribute('data-lu-daily'));
    } else {
      var raw = el.getAttribute('data-lu-countdown');
      target = new Date(raw);
      if (isNaN(target.getTime())) { el.hidden = true; return; }
    }

    var out = {
      d: $('[data-lu-cd-days]', el),
      h: $('[data-lu-cd-hours]', el),
      m: $('[data-lu-cd-mins]', el),
      s: $('[data-lu-cd-secs]', el)
    };
    var onEnd = el.getAttribute('data-lu-on-end'); // 'hide' | 'restart' | 'keep'

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = target - new Date();

      if (diff <= 0) {
        if (el.hasAttribute('data-lu-daily') || onEnd === 'restart') {
          target = el.hasAttribute('data-lu-daily')
            ? nextDailyDeadline(el.getAttribute('data-lu-daily'))
            : new Date(Date.now() + 24 * 3600 * 1000);
          diff = target - new Date();
        } else {
          if (onEnd === 'hide') {
            var host = el.closest('[data-lu-countdown-host]') || el;
            host.hidden = true;
          }
          diff = 0;
          clearInterval(timer);
        }
      }

      var total = Math.max(0, Math.floor(diff / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;

      if (out.d) out.d.textContent = pad(days);
      if (out.h) out.h.textContent = pad(hours);
      if (out.m) out.m.textContent = pad(mins);
      if (out.s) out.s.textContent = pad(secs);

      // Compacte inline weergave, bijv. "4 uur en 12 min"
      var inline = el.getAttribute('data-lu-inline');
      if (inline === 'true') {
        var txt = '';
        if (days > 0) txt += days + (days === 1 ? ' dag ' : ' dagen ');
        if (hours > 0 || days > 0) txt += hours + ' uur ';
        txt += mins + ' min';
        if (days === 0 && hours === 0) txt = mins + ' min ' + pad(secs) + ' sec';
        el.textContent = txt;
      }
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------------
     3. Reveal-on-scroll
     ---------------------------------------------------------------------- */
  function initReveal() {
    var items = $$('.lu-reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-lu-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-visible'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------------
     4. Hero-slider
     ---------------------------------------------------------------------- */
  function initHero(hero) {
    var track = $('[data-lu-hero-track]', hero);
    if (!track) return;
    var slides = $$('[data-lu-hero-slide]', track);
    if (slides.length < 2) return;

    var dotsWrap = $('[data-lu-hero-dots]', hero);
    var autoplay = hero.getAttribute('data-lu-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-lu-interval') || '6000', 10);
    var index = 0;
    var timer = null;

    var dots = slides.map(function (slide, i) {
      if (!dotsWrap) return null;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lu-hero__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Ga naar slide ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); });
      dotsWrap.appendChild(b);
      return b;
    });

    function go(i, stop) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      dots.forEach(function (d, di) { if (d) d.classList.toggle('is-active', di === index); });
      if (stop) pause();
    }

    function play() {
      if (!autoplay || reduceMotion || timer) return;
      timer = setInterval(function () { go(index + 1); }, interval);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }

    // Houd de dots in sync bij handmatig swipen
    var scrollDebounce;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        var closest = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; closest = i; }
        });
        index = closest;
        dots.forEach(function (d, di) { if (d) d.classList.toggle('is-active', di === index); });
      }, 90);
    }, { passive: true });

    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', pause);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else play();
    });

    play();
  }

  /* ------------------------------------------------------------------------
     5. Productgalerij
     ---------------------------------------------------------------------- */
  function initGallery(gallery) {
    var thumbs = $$('[data-lu-thumb]', gallery);
    var slides = $$('[data-lu-slide]', gallery);
    if (!thumbs.length || !slides.length) return;

    function show(i) {
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      thumbs.forEach(function (t, ti) {
        t.classList.toggle('is-active', ti === i);
        t.setAttribute('aria-selected', ti === i ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var n = (i + 1) % thumbs.length;
          thumbs[n].focus(); show(n);
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var p = (i - 1 + thumbs.length) % thumbs.length;
          thumbs[p].focus(); show(p);
        }
      });
    });

    // Variantwissel kan een specifieke afbeelding activeren
    gallery.addEventListener('lunea:media', function (e) {
      var id = e.detail && e.detail.mediaId;
      if (!id) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (idx > -1) show(idx);
    });
  }

  /* ------------------------------------------------------------------------
     6. Tabs
     ---------------------------------------------------------------------- */
  function initTabs(tabs) {
    var btns = $$('[role="tab"]', tabs);
    var panels = $$('[role="tabpanel"]', tabs);
    if (!btns.length) return;

    function select(i) {
      btns.forEach(function (b, bi) {
        b.setAttribute('aria-selected', bi === i ? 'true' : 'false');
        b.setAttribute('tabindex', bi === i ? '0' : '-1');
      });
      panels.forEach(function (p, pi) { p.hidden = pi !== i; });
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % btns.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + btns.length) % btns.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = btns.length - 1;
        if (n !== null) { e.preventDefault(); btns[n].focus(); select(n); }
      });
    });

    select(0);
  }

  /* ------------------------------------------------------------------------
     7. Sticky "in winkelwagen"
     ---------------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = $('[data-lu-sticky-atc]');
    var anchor = $('[data-lu-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Toon de balk zodra de echte koopknop uit beeld is
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });

    io.observe(anchor);
  }

  /* ------------------------------------------------------------------------
     8. Aantal-selector
     ---------------------------------------------------------------------- */
  function initQty(qty) {
    var input = $('[data-lu-qty-input]', qty);
    var minus = $('[data-lu-qty-minus]', qty);
    var plus = $('[data-lu-qty-plus]', qty);
    if (!input) return;

    function clamp() {
      var min = parseInt(input.min, 10) || 1;
      var maxAttr = parseInt(input.max, 10);
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < min) v = min;
      if (!isNaN(maxAttr) && maxAttr > 0 && v > maxAttr) v = maxAttr;
      input.value = v;
      if (minus) minus.disabled = v <= min;
      if (plus) plus.disabled = !isNaN(maxAttr) && maxAttr > 0 && v >= maxAttr;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minus) minus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; clamp(); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; clamp(); });
    input.addEventListener('change', function () {
      var min = parseInt(input.min, 10) || 1;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < min) { input.value = min; }
    });

    clamp();
  }

  /* ------------------------------------------------------------------------
     9. Gratis-verzendbalk (winkelwagen)
     ---------------------------------------------------------------------- */
  function updateFreeShipping(totalCents) {
    $$('[data-lu-freeship]').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-lu-freeship'), 10);
      if (!threshold) return;
      var remaining = Math.max(0, threshold - totalCents);
      var pct = Math.min(100, (totalCents / threshold) * 100);

      var fill = $('[data-lu-freeship-fill]', el);
      var text = $('[data-lu-freeship-text]', el);
      if (fill) fill.style.width = pct + '%';

      el.classList.toggle('lu-freeship--done', remaining === 0);

      if (text) {
        if (remaining === 0) {
          text.innerHTML = (text.getAttribute('data-done') || 'Gelukt! Je bestelling wordt gratis verzonden.');
        } else {
          var tpl = text.getAttribute('data-remaining') || 'Nog {{amount}} tot gratis verzending';
          text.innerHTML = tpl.replace('{{amount}}', '<strong>' + formatMoney(remaining) + '</strong>');
        }
      }
    });
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function refreshCart() {
    if (!$('[data-lu-freeship]')) return;
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateFreeShipping(cart.total_price); })
      .catch(function () { /* stil falen — de balk blijft op de serverwaarde staan */ });
  }

  /* ------------------------------------------------------------------------
     10. Recent bekeken (localStorage)
     ---------------------------------------------------------------------- */
  var RECENT_KEY = 'lunea:recently-viewed';

  function trackRecentlyViewed() {
    var el = $('[data-lu-track-product]');
    if (!el) return;
    var handle = el.getAttribute('data-lu-track-product');
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* privémodus of storage geblokkeerd — sla over */ }
  }

  /* ------------------------------------------------------------------------
     11. FAQ — sluit andere items (accordeon-gedrag, optioneel)
     ---------------------------------------------------------------------- */
  function initFaq(wrap) {
    if (wrap.getAttribute('data-lu-faq') !== 'single') return;
    var items = $$('details', wrap);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Init
     ---------------------------------------------------------------------- */
  function init(root) {
    root = root || document;
    $$('[data-lu-rail-wrap]', root).forEach(initRail);
    $$('[data-lu-countdown], [data-lu-daily]', root).forEach(initCountdown);
    $$('[data-lu-hero]', root).forEach(initHero);
    $$('[data-lu-gallery]', root).forEach(initGallery);
    $$('[data-lu-tabs]', root).forEach(initTabs);
    $$('[data-lu-qty]', root).forEach(initQty);
    $$('[data-lu-faq]', root).forEach(initFaq);
    initStickyAtc();
    initReveal();
    trackRecentlyViewed();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify theme editor — herinitialiseer bij sectiewijziging
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });

  // Winkelwagen bijwerken na toevoegen (werkt met de meeste ajax-carts)
  ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
    document.addEventListener(evt, refreshCart);
  });

  window.LuneaTheme = { init: init, refreshCart: refreshCart, formatMoney: formatMoney };
})();
